import { Grid, Skeleton } from "@mui/material";

export const InstallationAppointmentSkeleton = () => (
    <Grid container spacing={3}>
        <Grid item md={6} xs={12}>
            <Skeleton height={56} variant="rectangular" />
        </Grid>
        <Grid item md={6} xs={12}>
            <Skeleton height={56} variant="rectangular" />
        </Grid>
    </Grid>
);
